var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 1.46957 0.710714 0.960859 1.08579 0.585786C1.46086 0.210714 1.96957 0 2.5 0H14.5C15.0304 0 15.5391 0.210714 15.9142 0.585786C16.2893 0.960859 16.5 1.46957 16.5 2V10C16.5 10.5304 16.2893 11.0391 15.9142 11.4142C15.5391 11.7893 15.0304 12 14.5 12H2.5C1.96957 12 1.46086 11.7893 1.08579 11.4142C0.710714 11.0391 0.5 10.5304 0.5 10V2ZM2.5 1C2.23478 1 1.98043 1.10536 1.79289 1.29289C1.60536 1.48043 1.5 1.73478 1.5 2V2.217L8.5 6.417L15.5 2.217V2C15.5 1.73478 15.3946 1.48043 15.2071 1.29289C15.0196 1.10536 14.7652 1 14.5 1H2.5ZM15.5 3.383L10.742 6.238L15.5 9.114V3.384V3.383ZM15.466 10.261L9.771 6.82L8.5 7.583L7.228 6.82L1.534 10.26C1.5912 10.4724 1.71685 10.6601 1.89149 10.7938C2.06613 10.9276 2.28001 11.0001 2.5 11H14.5C14.7199 11.0001 14.9336 10.9278 15.1083 10.7942C15.2829 10.6607 15.4086 10.4732 15.466 10.261ZM1.5 9.114L6.258 6.238L1.5 3.383V9.113V9.114Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.262ca9c66b0c239d5b9c251314070874.svg";
export { ForwardRef as ReactComponent };